// Реестр отложенных вызовов виджета. Всё, что тикает — поллинг ленты,
// автооткрытие, тизер-приглашение, presence-heartbeat, паузы раскрытия
// пузырей, — заводится ТОЛЬКО здесь, поэтому один stop() гасит виджет
// целиком: у заблокированного посетителя (spec §12) не остаётся скрытых
// таймеров, которые продолжали бы ходить в публичный API уже после того, как
// виджет исчез с экрана. stop() необратим — «разбанили» узнаёт следующая
// загрузка страницы, а не оживший таймер.
//
// Чистый модуль без DOM — тестируется в изоляции (timers.test.mjs), как
// receipt.ts и delay.ts.

/** Дескриптор таймера (в браузере setTimeout возвращает число). */
export type TimerHandle = number;

export interface Timers {
  /** Отложенный вызов; после stop() не заводится вовсе — вернёт null. */
  after(delay: number, fn: () => void): TimerHandle | null;
  /** Периодический вызов; после stop() не заводится. */
  every(delay: number, fn: () => void): void;
  /** Снять один таймер (null — снимать нечего). */
  clear(handle: TimerHandle | null): void;
  /** Снять ВСЕ таймеры и запретить новые. Обратного пути нет. */
  stop(): void;
}

export function createTimers(): Timers {
  const pending = new Set<TimerHandle>();
  const repeating = new Set<TimerHandle>();
  let stopped = false;

  return {
    after(delay, fn) {
      if (stopped) return null;

      // Отработавший таймер выписываем из реестра сам собой: длинная сессия не
      // должна копить дескрипторы уже сыгравших пауз.
      const handle: TimerHandle = setTimeout(() => {
        pending.delete(handle);
        fn();
      }, delay);
      pending.add(handle);
      return handle;
    },

    every(delay, fn) {
      if (stopped) return;

      repeating.add(setInterval(fn, delay));
    },

    clear(handle) {
      if (handle === null) return;

      pending.delete(handle);
      clearTimeout(handle);
    },

    stop() {
      stopped = true;
      pending.forEach((handle) => clearTimeout(handle));
      repeating.forEach((handle) => clearInterval(handle));
      pending.clear();
      repeating.clear();
    },
  };
}
